import ThisModule from "./PageContent";

export default ThisModule;
